webpackJsonp([4],{

/***/ 127:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(174)
}
var Component = __webpack_require__(30)(
  /* script */
  __webpack_require__(134),
  /* template */
  __webpack_require__(249),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 133:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__dirname) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuefire__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuefire___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuefire__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_resource__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_router__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_smoothscroll__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_smoothscroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_smoothscroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__App__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__App__);










__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vuefire___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_vue_smoothscroll___default.a);

var router = new __WEBPACK_IMPORTED_MODULE_5_vue_router__["a" /* default */]({
  mode: 'history',
  base: __dirname,
  routes: [{
    path: '*',
    redirect: '/home'
  }, {
    name: 'home',
    path: '/home'
  }, {
    name: 'bio',
    path: '/bio'
  }, {
    name: 'work',
    path: '/work'
  }],
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      // savedPosition is only available for popstate navigations.
      return savedPosition;
    } else {
      var position = {};
      // new navigation.
      // scroll to anchor by returning the selector
      if (to.hash) {
        position.selector = to.hash;

        // specify offset of the element
        if (to.hash === '#anchor2') {
          position.offset = { y: 100 };
        }
      }
      // check if any matched route config has meta that requires scrolling to top
      if (to.matched.some(function (m) {
        return m.meta.scrollToTop;
      })) {
        // cords will be used if no selector is provided,
        // or if the selector didn't match any element.
        position.x = 0;
        position.y = 0;
      }
      // if the returned position is falsy or an empty object,
      // will retain current scroll position.
      return position;
    }
  }
});

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].config.productionTip = false;

/* eslint-disable no-new */
var vm = new __WEBPACK_IMPORTED_MODULE_2_vue__["default"](__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
  el: '#app',
  router: router,
  mounted: function mounted() {
    scrollToSection(router.currentRoute.name);
  }
}, __WEBPACK_IMPORTED_MODULE_7__App___default.a)).$mount('#app');

var scrolling = false;

function updateRoute(route) {
  router.push(route);
}

function scrollToSection(section) {
  var animate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  switch (section) {
    case 'home':
    case 'work':
    case 'bio':
      var selector = document.querySelector('#' + section);
      if (selector !== null) {
        if (!scrolling && animate) {
          vm.$SmoothScroll(selector);
        } else {
          selector.scrollIntoView();
        }
      } else {
        setTimeout(function () {
          scrollToSection(section);
        }, 3500);
      }
      break;
  }
}

function sectionInViewport(e) {
  var sections = document.querySelectorAll('.section');
  var anonArr = [];
  var inViewport = [];

  anonArr.forEach.call(sections, function (section) {
    var sectionTop = section.offsetTop;
    var sectionBottom = section.offsetTop + section.offsetHeight;
    var viewportBottom = window.scrollY + window.innerHeight;
    var viewportTop = window.scrollY;
    var index = inViewport.indexOf(section.id);

    if (viewportBottom > sectionTop && viewportTop < sectionBottom) {
      if (index === -1) {
        inViewport.push(section.id);
      }
    } else {
      if (index > -1) {
        inViewport.splice(index, 1);
      }
    }
  });

  if (inViewport.length === 1) {
    updateRoute(inViewport[0]);
  }
}

router.beforeEach(function (to, from, next) {
  var section = to.name;
  scrollToSection(section);
  next();
});

router.afterEach(function (to, from) {
  var selector = document.querySelector('#navigation');
  var section = to.name;
  var html = document.querySelector('html');
  var body = document.querySelector('body');

  if ((typeof selector === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(selector)) !== undefined && selector !== null) {
    selector.classList.remove('show');
    html.classList.remove('locked');
    body.classList.remove('locked');
  } else {
    scrollToSection(section);
  }
});

window.addEventListener('wheel', function (e) {
  scrolling = true;
  sectionInViewport(e);
  clearTimeout(timeout);
  var timeout = setTimeout(function () {
    scrolling = false;
  }, 350);
}, { passive: true });

window.addEventListener('touchmove', function (e) {
  scrolling = true;
  sectionInViewport(e);
  clearTimeout(timeout);
  var timeout = setTimeout(function () {
    scrolling = false;
  }, 350);
}, { passive: true });
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "/"))

/***/ }),

/***/ 134:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Heading_vue__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Heading_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Heading_vue__);
//
//
//
//
//
//
//
//
//
//
//
//



var Home = function Home() {
  return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 256));
};
var Work = function Work() {
  return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 257));
};
var Bio = function Bio() {
  return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 255));
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: {
    Heading: __WEBPACK_IMPORTED_MODULE_0__components_Heading_vue___default.a,
    Home: Home,
    Work: Work,
    Bio: Bio
  },
  updated: function updated() {
    setTimeout(function () {
      document.querySelector('html').classList.remove('loading');
      document.querySelector('body').classList.remove('loading');
    }, 1000);
  }
});

/***/ }),

/***/ 135:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Logo_vue__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Logo_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Logo_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Navigation_vue__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Navigation_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Navigation_vue__);
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'home',
  data: function data() {
    return {
      basic: Array
    };
  },

  firebase: {
    basic: {
      source: __WEBPACK_IMPORTED_MODULE_0__firebase__["a" /* db */].ref('basic'),
      cancelCallback: function cancelCallback(err) {
        console.error(err);
      }
    },
    work: {
      source: __WEBPACK_IMPORTED_MODULE_0__firebase__["a" /* db */].ref('projects').orderByChild('weight'),
      cancelCallback: function cancelCallback(err) {
        console.error(err);
      }
    },
    bio: {
      source: __WEBPACK_IMPORTED_MODULE_0__firebase__["a" /* db */].ref('bio'),
      cancelCallback: function cancelCallback(err) {
        console.error(err);
      }
    },
    stills: {
      source: __WEBPACK_IMPORTED_MODULE_0__firebase__["a" /* db */].ref('stills').orderByChild('weight'),
      cancelCallback: function cancelCallback(err) {
        console.error(err);
      }
    }
  },
  components: {
    Logo: __WEBPACK_IMPORTED_MODULE_1__Logo_vue___default.a,
    Navigation: __WEBPACK_IMPORTED_MODULE_2__Navigation_vue___default.a
  }
});

/***/ }),

/***/ 136:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'logo'
});

/***/ }),

/***/ 137:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase__ = __webpack_require__(74);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'navigation',
  data: function data() {
    return {
      basic: Array
    };
  },

  firebase: {
    basic: {
      source: __WEBPACK_IMPORTED_MODULE_0__firebase__["a" /* db */].ref('basic'),
      cancelCallback: function cancelCallback(err) {
        console.error(err);
      }
    },
    work: {
      source: __WEBPACK_IMPORTED_MODULE_0__firebase__["a" /* db */].ref('projects').orderByChild('weight'),
      cancelCallback: function cancelCallback(err) {
        console.error(err);
      }
    },
    bio: {
      source: __WEBPACK_IMPORTED_MODULE_0__firebase__["a" /* db */].ref('bio'),
      cancelCallback: function cancelCallback(err) {
        console.error(err);
      }
    },
    stills: {
      source: __WEBPACK_IMPORTED_MODULE_0__firebase__["a" /* db */].ref('stills').orderByChild('weight'),
      cancelCallback: function cancelCallback(err) {
        console.error(err);
      }
    }
  },
  methods: {
    toggleMenu: function toggleMenu() {
      var html = document.querySelector('html');
      var body = document.querySelector('body');
      var nav = document.querySelector('#navigation');

      if (html.classList.contains('locked') && body.classList.contains('locked') && nav.classList.contains('show')) {
        html.classList.remove('locked');
        body.classList.remove('locked');
        nav.classList.remove('show');
      } else {
        html.classList.add('locked');
        body.classList.add('locked');
        nav.classList.add('show');
      }
    }
  }
});

/***/ }),

/***/ 171:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 172:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 173:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 174:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 175:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 244:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(173)
}
var Component = __webpack_require__(30)(
  /* script */
  __webpack_require__(135),
  /* template */
  __webpack_require__(248),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-d91a5c58",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 245:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(175)
}
var Component = __webpack_require__(30)(
  /* script */
  __webpack_require__(136),
  /* template */
  __webpack_require__(250),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-f4021a6e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 246:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(171)
  __webpack_require__(172)
}
var Component = __webpack_require__(30)(
  /* script */
  __webpack_require__(137),
  /* template */
  __webpack_require__(247),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5631839c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 247:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "navigation"
    }
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": _vm.toggleMenu
    }
  }, [_vm._m(0)]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "menu"
    }
  }, [_c('div', {
    attrs: {
      "id": "menu-inner"
    }
  }, [_c('h4', {
    attrs: {
      "id": "title"
    }
  }, [_vm._v("Thomas van Krugten")]), _vm._v(" "), _c('ul', {
    attrs: {
      "id": "contact"
    }
  }, [_vm._l((_vm.basic), function(data, index) {
    return (data['.key'] == 'contact') ? _c('li', {
      key: index
    }, [_vm._v(_vm._s(data.phone))]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.basic), function(data, index) {
    return (data['.key'] == 'contact') ? _c('li', {
      key: index
    }, [_vm._v(_vm._s(data.email))]) : _vm._e()
  }), _vm._v(" "), _vm._m(1)], 2), _vm._v(" "), _c('span', {
    attrs: {
      "id": "separator"
    }
  }), _vm._v(" "), _c('ul', {
    attrs: {
      "id": "main-nav"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "work",
      "tag": "li"
    }
  }, [_c('a', [_vm._v("Work")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "bio",
      "tag": "li"
    }
  }, [_c('a', [_vm._v("Bio")])])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    attrs: {
      "id": "mobm"
    }
  }, [_c('div', {
    staticClass: "con"
  }, [_c('div', {
    staticClass: "bar top"
  }), _vm._v(" "), _c('div', {
    staticClass: "bar middle"
  }), _vm._v(" "), _c('div', {
    staticClass: "bar bottom"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "https://vimeo.com/thomasvankrugten",
      "target": "_blank"
    }
  }, [_vm._v("vimeo.com/thomasvankrugten")])])
}]}

/***/ }),

/***/ 248:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "header"
    }
  }, [_c('div', {
    attrs: {
      "id": "header-inner"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "home"
    }
  }, [_c('logo')], 1), _vm._v(" "), _c('navigation', {
    attrs: {
      "basic": _vm.basic
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 249:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid",
    attrs: {
      "id": "app"
    }
  }, [_c('heading'), _vm._v(" "), _c('home', {
    staticClass: "section"
  }), _vm._v(" "), _c('work', {
    staticClass: "section"
  }), _vm._v(" "), _c('bio', {
    staticClass: "section"
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 250:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "logo"
    }
  })
},staticRenderFns: []}

/***/ }),

/***/ 252:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 74:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return db; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);


var firebaseApp = __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.initializeApp({
  apiKey: 'AIzaSyAGc1hS555qGeg4Y47PFMPfiIanLvyIlcg',
  authDomain: 'thomas-fe69b.firebaseapp.com',
  databaseURL: 'https://thomas-fe69b.firebaseio.com',
  projectId: 'thomas-fe69b',
  storageBucket: 'thomas-fe69b.appspot.com',
  messagingSenderId: '808989085103'
});

var db = firebaseApp.database();

/***/ })

},[133]);


// WEBPACK FOOTER //
// static/js/app.1d8110f053e09ed2fc30.js